/**
 * design-mode.js
 * Adds the .shopify-design-mode class to <html> when the theme
 * is loaded inside the Shopify Theme Editor.
 *
 * Loaded with `defer` — runs after DOM is parsed, which is safe
 * for the editor because Shopify waits for the page to be fully
 * interactive before injecting editor chrome.
 */
if (Shopify.designMode) {
  document.documentElement.classList.add('shopify-design-mode');
}
